@if (showFieldAsEdit && !readOnlyUser) {
  <div
    class="my-4">
    <topo-color-item-select
      [selectedUId]="selectedStepUId"
      [label]="selectedStatusName"
      [colorCode]="selectedStatusColorCode"
      itemLabel="statusName"
      itemColorCode="statusHtmlColorCode"
      [items]="workflowStepListItems"
      [isXLarge]="true"
      (itemSelected)="stepSelected($event)"
    isActive="isActive"></topo-color-item-select>
  </div>
} @else {
  <div
    class="workflow-status-readonly"
    style="width: calc(100% - 2rem)"
    fxLayout="row"
    fxLayoutAlign="start center">
    <div
      class="workflow-color"
      [ngStyle]="{ 'background-color': selectedStatusColorCode }">
      &nbsp;
    </div>
    <div class="workflow-status">{{ selectedStatusName }}</div>
  </div>
}
<topo-workflow-transition-form
  [isActive]="showTransitionForm"
  [editView]="workflowTransitionView"
  [document]="document"
  [schema]="schema"
  [workflowStepUId]="workflowTransitionStepUId"
  (close)="onCloseTransitionForm()"
  (save)="onSaveTransitionForm($event)"
[dataset]="dataset"></topo-workflow-transition-form>
